// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1l0BQ","overflowing":"ReadFullNote_overflowing__2O7Gh"};